import { environment } from './../../../environments/environment';
import { ErrorHandleService } from './error-Handle.service';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class MainService {
    private baseUrl = environment.apiURL ;
    // private baseUrl = 'http://localhost:5000/api';

  private username = 'admin';
  private password = 'digisoft';
  private authToken = '099f82a8e1b38c38dab5ec1b6bd093e0';
  constructor(@Inject(PLATFORM_ID) private platformId: Object,private http: HttpClient, private errorHandleService: ErrorHandleService) {
    if (isPlatformBrowser(this.platformId)) {
     // this.authToken = localStorage.getItem('auth_token');
    }
    
  }
 
  GetMedyabar(url) {
    return this.http.get(url,
      { headers: { 'Authorization':`Bearer ${this.authToken}` }});
  }

  Get(url) {
    return this.http.get(this.baseUrl + url,
      { headers: { 'Authorization':`Bearer ${this.authToken}`  }})
      .catch(this.errorHandleService.HandleError);
  }
  GetBasic(url) {
    return this.http.get(this.baseUrl + url,
      { headers: { 'Authorization': 'Basic ' + 'YWRtaW46ZGlnaXNvZnQ=' } })
      .catch(this.errorHandleService.HandleError);
  }
  GetFREE(url) {
    return this.http.get(url)
      .catch(this.errorHandleService.HandleError);
  }
 
  GetID(url, id) {
    return this.http.get(this.baseUrl + url + '/' + id,
      { headers: { 'Authorization':`Bearer ${this.authToken}`  }})
      .catch(this.errorHandleService.HandleError);
  }
  Create(url, obj: any, res?: any) {
    return this.http.post(this.baseUrl + url, obj,
      { headers: { 'Authorization':`Bearer ${this.authToken}`  }})
   //   .catch(this.errorHandleService.HandleError);
  }
  CreateAuthorize(url, obj: any, res?: any) {
    return this.http.post(this.baseUrl + url, obj,
      { headers: { 'Authorization': 'Basic ' + btoa(this.username + ':' + this.password) } })
   //   .catch(this.errorHandleService.HandleError);
  }
  CreateFree(url, obj: any, res?: any) {
    return this.http.post( url, obj,
      { headers: { 'Authorization':`Bearer ${this.authToken}`  }})
      .catch(this.errorHandleService.HandleError);
  }
  Update(url, obj: any) {
    return this.http.put(this.baseUrl + url, obj,
      { headers: { 'Authorization':`Bearer ${this.authToken}`  }})
      .catch(this.errorHandleService.HandleError);
  }
  Patch(url, id: number, obj: any) {
    return this.http.patch(this.baseUrl + url + '/' + id, obj,
    { headers: { 'Authorization':`Bearer ${this.authToken}`  }})
      .catch(this.errorHandleService.HandleError);
  }
  PatchStr(url, id: number, str: string) {
    return this.http.patch(this.baseUrl + url + '/' + id + '/' + str,
    { headers: { 'Authorization':`Bearer ${this.authToken}`  }})
      .catch(this.errorHandleService.HandleError);
  }
  PatchFotoLink(url, id: number, obj:any) {
    return this.http.patch(this.baseUrl + url + '/' + id , obj,
      { headers: { 'Authorization': 'Basic ' + btoa(this.username + ':' + this.password) } })
      .catch(this.errorHandleService.HandleError);
  }
  Remove(url, id: number) {
    return this.http.delete(this.baseUrl + url + '/' + id,
    { headers: { 'Authorization':`Bearer ${this.authToken}`  }})
  }

  Search(url, obj: string) {
    return this.http.post(this.baseUrl + url + obj,
      { headers: { 'Authorization':`Bearer ${this.authToken}`  }})
      .catch(this.errorHandleService.HandleError);
  }

}
